export default __webpack_public_path__ + "static/media/Draw.3a00ec67.svg";